import { render, staticRenderFns } from "./ModalGetResponsible.vue?vue&type=template&id=6d14c4e2&scoped=true&"
import script from "./ModalGetResponsible.vue?vue&type=script&lang=js&"
export * from "./ModalGetResponsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14c4e2",
  null
  
)

export default component.exports